module.exports = __webpack_public_path__ + "media/Digrab_Showreel.b3362ac9.mp4";